module.exports = __webpack_public_path__ + "media/assets/images/flags/np-a5831ced960865f809fdf7f825dde954.svg";